// React Basic and Bootstrap
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Row, Col, Container } from "reactstrap";

//Import Icons
import FeatherIcon from "feather-icons-react";
import bgImage from "../../../assets/images/app/bg-image.png";

//Import components
import { AccordianCommon1 } from "../../../components/Shared/AccordianCommon";

class PageFaq extends Component {
  componentDidMount() {
    document.body.classList = "";
    window.addEventListener("scroll", this.scrollNavigation, true);
  }

  // Make sure to remove the DOM listener when the component is unmounted.
  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollNavigation, true);
  }

  scrollNavigation = () => {
    var doc = document.documentElement;
    const navBar = document.getElementById("topnav");
    var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    if (navBar != null) {
      if (top > 80) {
        navBar.classList.add("nav-sticky");
      } else {
        navBar.classList.remove("nav-sticky");
      }
    }
  };

  render() {
    return (
      <React.Fragment>

        {/* breadcrumb */}
        <section
          className="bg-half-170 bg-light d-table w-100 d-print-none"
          style={{ background: `url(${bgImage}) center center` }}
        >
          <Container>
            <Row className="justify-content-center">
              <Col lg={12} className="text-center">
                <div className="pages-heading">
                  <h4 className="title"> Frequently Asked Questions </h4>
                </div>
              </Col>
            </Row>

            <div className="position-breadcrumb">
              <nav aria-label="breadcrumb" className="d-inline-block">
                <ul className="breadcrumb rounded shadow mb-0 px-4 py-2">
                  <li className="breadcrumb-item"><Link to="/">Home</Link></li>{" "}
                  <li className="breadcrumb-item active" aria-current="page">FAQ</li>
                </ul>
              </nav>
            </div>
          </Container>
        </section>

        <div className="position-relative">
          <div className="shape overflow-hidden text-white">
            <svg
              viewBox="0 0 2880 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
                fill="currentColor"
              ></path>
            </svg>
          </div>
        </div>

        <section className="section">
          <Container>
            <Row className="justify-content-center">
              <Col lg={9}>
                <div className="section-title mb-4 pb-2 text-center">
                  <p className="text-muted para-desc mb-0 mx-auto">
                    Find answers to commonly asked questions below. If you can't find what you're looking for, please{" "}
                    <Link to="/contact" className="text-primary fw-bold">contact us</Link>.
                  </p>
                </div>

                <Row className="mt-4">
                  <Col md={12} className="mt-4 pt-2">
                    <AccordianCommon1
                      question1="How does the DigitCard app work?"
                      answer1="DigitCard helps you create, manage, organize, and share digital business cards effortlessly. You can instantly access your digital cards, share them with clients and partners via QR codes or links, and keep all your professional contacts organized in one secure place."

                      question2="How do I share my digital business card?"
                      answer2="Sharing your digital business card is simple. You can send using unique tokens."

                      question3="Is my information secure with DigitCard?"
                      answer3="Yes, absolutely. We use industry-standard encryption and security measures to protect your professional data and contact information. Your account and digital business cards are safe and secure with us."

                      question4="What payment methods do you accept?"
                      answer4="We accept all major credit and debit cards. All transactions are processed securely through our payment gateway partners."
                    />
                  </Col>
                </Row>

                <Row className="my-md-5 pt-md-3 my-4 pt-2 pb-lg-5 mt-sm-0 pt-sm-0 justify-content-center">
                  <Col xs={12} className="text-center">
                    <div className="section-title">
                      <h4 className="title mb-4">Still have questions?</h4>
                      <p className="text-muted para-desc mx-auto">
                        Can't find the answer you're looking for? Please{" "}
                        <Link to="/contact" className="text-primary fw-bold">contact us</Link>{" "}
                        and we'll be happy to help.
                      </p>
                      <Link to="/contact" className="btn btn-primary mt-4">
                        <i className="uil uil-phone"></i> Contact us
                      </Link>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}
export default PageFaq;

